var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CarbonFootprintSummary',{attrs:{"emissionsByScope":_vm.emissionsByScope}}),(_vm.monthlyReportAvailable)?_c('MonthlyTotalEmissionsBarGraph'):_vm._e(),(_vm.multipleBusinessUnits)?_c('BusinessUnitTable'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }